export default {
	title: "",
	subtitle: "Subscription Details",
  path: "subscription_details",
  paragraph: 'With this endpoint, you can retrieve detailed information about a specific subscription by providing its unique ID.',
  request: {
    method: "GET",
		endpoint: "/subscriptions/:id",
		responses: {
      "data": {
        "canceled_at": null,
        "canceled_by_payer": null,
        "canceled_reason": null,
        "completed_at": null,
        "currency": "BRL",
        "cycles": 12,
        "description": "some description",
        "free_days": 0,
        "frequency": "month",
        "from_bank_account_id": null,
        "id": "86c142b7-9b94-413d-9894-74c35835f666",
        "inserted_at": "2025-09-12T21:00:54.680247",
        "payer_bank_account_id": null,
        "payer_card_id": "2241cdcd-bc2c-4361-8079-435b322e6f1f",
        "payment_method": "card",
        "status": "active",
        "subject_id": "2c90ad60-31de-4624-a852-60960a814e2c",
        "to_bank_account_id": "504fc315-ce61-4179-b19a-e4617eaae30f",
        "total_retry_attempts": 0,
        "trial_days": 0,
        "updated_at": "2025-09-12T21:00:54.783049",
        "value": "100"
      }
    }
	},
  pathPayload: [
    {
      name: "id",
      type: "string",
      required: true,
      description: "Subscription ID"
    }
  ],
}



// WEBPACK FOOTER //
// ./src/components/documentation/data/Subscription/SubscriptionDetails.js